import { useField, ErrorMessage } from "formik";
import { FormGroup, Label } from "reactstrap";

type CustomCheckboxProps = {
  name: string;
  value?: string; // Optional for isSingle
  fieldClassName?: string;
  checkboxBtnTitle: string;
  errorComponent?: React.ComponentType<any> | string;
  handleOnChange?: (
    updatedValue: string[] | string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  isLast?: boolean;
  isSingle?: boolean; // NEW FLAG
};

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  name,
  value = "0", // default value for single checkbox
  fieldClassName = "form-check-input",
  checkboxBtnTitle,
  errorComponent = "div",
  handleOnChange,
  isLast,
  isSingle = false,
}) => {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const isChecked = isSingle
    ? field.value === "1" || field.value === true
    : Array.isArray(field.value) && field.value.includes(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;

    if (isSingle) {
      const updatedValue = checked ? "1" : "0";
      setValue(updatedValue);
      handleOnChange?.(updatedValue, e);
    } else {
      const fieldValue: string[] = Array.isArray(field.value)
        ? field.value
        : [];
      const updatedValue = checked
        ? [...fieldValue, value]
        : fieldValue.filter((v) => v !== value);
      setValue(updatedValue);
      handleOnChange?.(updatedValue, e);
    }
  };

  const isShowError = isLast && meta.touched && meta.error;
  const id = `${name}_${value}`;

  return (
    <FormGroup>
      <div className="d-flex align-items-center form-check ps-0">
        <input
          type="checkbox"
          id={id}
          name={name}
          value={value}
          checked={isChecked}
          onChange={handleChange}
          className={fieldClassName}
        />
        <Label htmlFor={id} className="ms-2 mb-0 pointer">
          {checkboxBtnTitle}
        </Label>
      </div>
      {isShowError && (
        <ErrorMessage
          name={name}
          component={errorComponent}
          className="invalid-feedback d-block"
        />
      )}
    </FormGroup>
  );
};

export default CustomCheckbox;
